import { get } from './index.js';

/**
 * 获取人才列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} params.specialty - 专业领域筛选
 * @param {string} params.skills - 技能筛选(多个用逗号分隔)
 * @param {string} params.languages - 语言筛选(多个用逗号分隔)
 * @param {string} params.search - 搜索关键词
 * @param {string} params.sortBy - 排序字段
 * @param {string} params.sortOrder - 排序方向
 * @returns {Promise} 人才列表响应
 */
export const getTalents = async (params = {}) => {
  const { page = 1, pageSize = 12, ...rest } = params;
  try {
    // 调用实际API
    const response = await get('/talent/list', { page, pageSize, ...rest });
    
    // 适配实际API返回的数据结构
    const adaptedData = {
      records: response.records.map(record => ({
        talentId: record.talentId,
        imageId: record.imageId,
        data: record.data,
        // 添加其他必要字段，使用默认值
        experience: 0,
        rating: 0,
        viewCount: 0,
        bio: '',
        languages: [],
        education: [],
        workExperience: [],
        projects: [],
        publications: [],
        awards: [],
        services: [],
        availability: 'available',
        hourlyRate: 0,
        location: record.data.country,
        email: '',
        phone: '',
        website: '',
        linkedin: '',
        github: '',
        portfolio: '',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      })),
      total: response.total || 0,
      current: response.current || page,
      pages: response.pages || 1,
      size: response.size || pageSize
    };
    
    console.log('🎯 适配后的人才数据:', adaptedData);
    return adaptedData;
  } catch (error) {
    console.error('❌ 获取人才列表失败:', error);
    throw error;
  }
};

/**
 * 根据ID获取人才详情
 * @param {string} id - 人才ID
 * @returns {Promise} 人才详情响应
 */
export const getTalentById = (id) => {
  return get(`/talent/${id}`);
};

/**
 * 获取专业领域列表
 * @returns {Promise} 专业领域列表响应
 */
export const getSpecialties = () => {
  return get('/talents/specialties');
};

/**
 * 获取技能标签列表
 * @param {string} specialty - 专业领域(可选)
 * @returns {Promise} 技能列表响应
 */
export const getSkills = (specialty = '') => {
  const params = specialty ? { specialty } : {};
  return get('/talents/skills', params);
};

/**
 * 获取语言列表
 * @returns {Promise} 语言列表响应
 */
export const getLanguages = () => {
  return get('/talents/languages');
};

/**
 * 获取推荐人才(同专业领域)
 * @param {string} talentId - 当前人才ID
 * @param {number} limit - 返回数量限制
 * @returns {Promise} 推荐人才列表响应
 */
export const getRecommendedTalents = (talentId, limit = 4) => {
  return get(`/talents/${talentId}/recommendations`, { limit });
};

/**
 * 搜索人才
 * @param {Object} params - 搜索参数
 * @param {string} params.q - 搜索关键词
 * @param {string} params.specialty - 专业领域筛选
 * @param {string} params.location - 地区筛选
 * @returns {Promise} 搜索结果响应
 */
export const searchTalents = (params = {}) => {
  return get('/talents/search', params);
}; 